/**
 * Poslovnice firme "više restorana" u izveštajima. Endpoint limits/transactions/company/{id} vraća radnike i
 * transakcije cele firme: sopstvene i svih poslovnica (company_id svake je u odgovoru). Izbor poslovnica je u traci
 * izveštaja (store: report/selectedBranches), prazan izbor znači sve. Stari tabovi njime filtriraju umesto da
 * odbacuju sve što nije baš firma naloga.
 */
export default {
  computed: {
    /** Firma naloga i njene poslovnice: [{ id, name }] */
    reportBranches() {
      const company = this.$store.state.company;
      if (!company) {
        return [];
      }
      const children = Array.isArray(company.children) ? company.children : [];
      return [company, ...children].map((item) => ({ id: item.id, name: item.name }));
    },
    /** Kolona "Poslovnica" u tabelama ima smisla samo kad firma ima više poslovnica. */
    hasBranches() {
      return this.reportBranches.length > 1;
    },
    /** Izabrane poslovnice (sve kad nije izabrana nijedna ili izbor više ne važi za ovu firmu). */
    selectedBranchIds() {
      const known = this.reportBranches.map((branch) => branch.id);
      const picked = (this.$store.state.report.selectedBranches || []).filter((id) => known.includes(id));
      return picked.length ? picked : known;
    },
  },
  methods: {
    /**
     * Poslovnica iz izveštaja koji je grupisan po nazivu firme (npr. order-more-restaurants) je među izabranim.
     * Naziv se poredi bez razlike u razmacima i velikim slovima; nepoznata firma se vidi samo dok su izabrane sve.
     */
    branchNameSelected(name) {
      const clean = (value) => String(value || "").replace(/\s+/g, " ").trim().toLowerCase();
      if (!clean(name)) {
        return true;
      }
      const branch = this.reportBranches.find((item) => clean(item.name) === clean(name));
      return branch ? this.selectedBranchIds.includes(branch.id) : this.selectedBranchIds.length === this.reportBranches.length;
    },
    /** Transakcija ili radnik (oboje nose company_id) pripada izabranoj poslovnici. */
    inSelectedBranches(item) {
      return this.selectedBranchIds.includes(item && item.company_id);
    },
    /**
     * Radnik (grupa iz odgovora: { user, limitTransactions }) je u izabranim poslovnicama: ili je njegova poslovnica
     * izabrana ili ima transakciju u njoj. Radnik bez poslovnice u odgovoru se ne krije (stariji odgovori nemaju
     * company_id uz radnika).
     */
    groupInSelectedBranches(group) {
      const user = group && group.user;
      if (!user || user.company_id == null || this.inSelectedBranches(user)) {
        return true;
      }
      return (group.limitTransactions || []).some((transaction) => this.inSelectedBranches(transaction));
    },
  },
};
